/**
 * What an organization that never saved its settings gets: exactly what Desk did before the settings existed —
 * everything the server allows is on, generative answers are off, low-confidence answers are shown as such.
 */
export const REPOSITORY_INTELLIGENCE_SETTING_DEFAULTS = Object.freeze({
    enabled: true,
    askEnabled: true,
    generativeEnabled: false,
    analyzeEnabled: true,
    strictAnswers: false,
});
/**
 * The fixed texts of Desk's Repository Intelligence refusals. They are the contract between the API and the screens:
 * the API answers with exactly these, and the screens tell, say, "switched off for the organization" (a next step for
 * an administrator) from "not for you" (nothing to do) by them — and then show their own words, never the message.
 */
export const REPOSITORY_INTELLIGENCE_MESSAGES = {
    /** 403: not the system Super Admin of the service-provider organization holding the route's permission. */
    SUPER_ADMIN_ONLY: 'Repository Intelligence is available to the system Super Admin only',
    /** 503: this Desk server is not set up to reach Repository Intelligence. */
    NOT_CONFIGURED: 'Repository Intelligence is not enabled',
    /** 403: the organization switched Repository Intelligence off. */
    ORGANIZATION_DISABLED: 'Repository Intelligence is not enabled for your organization',
    /** 403: the organization switched questions off. */
    ASK_DISABLED: 'Questions about code are not enabled for your organization',
    /** 403: the organization switched change analysis off. */
    ANALYZE_DISABLED: 'Change analysis is not enabled for your organization',
    /** 404: no live repository link with that id in the caller's organization. */
    LINK_NOT_FOUND: 'Repository link not found',
    /** 404: nobody asked Repository Intelligence to index this repository from Desk. */
    NO_REGISTRATION: 'No Repository Intelligence registration was requested for this repository',
    /** 400: generative answers are not approved, so the organization cannot consent to them yet. */
    GENERATIVE_NOT_APPROVED: 'Generative answers are not available',
};
//# sourceMappingURL=repository-intelligence-settings.js.map